import moment from 'moment';

class QucikSort {
  constructor(options) {
    this.startSorting = this.startSorting.bind(this);
    this.swap = this.swap.bind(this);
    this.partition = this.partition.bind(this);
    this.quickSort = this.quickSort.bind(this);
    this.key = options.key;
    this.type = options.type;
  }
  swap(items, firstIndex, secondIndex) {
    const temp = items[firstIndex];
    items[firstIndex] = items[secondIndex];
    items[secondIndex] = temp;
  }
  partition(items, left, right) {
    let pivot = null;
    switch (this.key) {
      case 'comment_count':
        pivot = parseInt(items[Math.floor((right + left) / 2)][this.key], 10);
        break;
      case 'post_date':
        pivot = items[Math.floor((right + left) / 2)][this.key];
        break;
      case 'post_title':
        pivot = items[Math.floor((right + left) / 2)][this.key];
      default:
        break;

    }
    let i = left;
    let j = right;
    while (i <= j) {
      if (this.key === 'comment_count') {
        while (parseInt(items[i][this.key], 10) < pivot) {
          i++;
        }
      } else if (this.key === 'post_date') {
        while (moment(items[i][this.key]).isBefore(pivot)) {
          // moment(date_time).isAfter('2014-03-24T01:14:00Z');
          i++;
        }
      } else if (this.key === 'post_title') {
        while (items[i][this.key] < pivot) {
          i++;
        }        
      }

      if (this.key === 'comment_count') {
        while (parseInt(items[j][this.key], 10) > pivot) {
          j--;
        }
      } else if (this.key === 'post_date') {
        while (moment(items[j][this.key]).isAfter(pivot)) {
          j--;
        }
      } else if (this.key === 'post_title') {
        while (items[j][this.key] > pivot) {
          j--;
        }        
      }

      if (i <= j) {
        this.swap(items, i, j);
        i++;
        j--;
      }
    }
    return i;
  }
  quickSort(items, left, right) {
    let index;
    if (items.length > 1) {
      index = this.partition(items, left, right);
      if (left < index - 1) {
        this.quickSort(items, left, index - 1);
      }
      if (index < right) {
        this.quickSort(items, index, right);
      }
    }
    return items;
  }
  startSorting(items) {
    const result = this.quickSort(items, 0, items.length - 1);
    const finalResult = [];
    if (this.type === 'dsc') {
      for (let index = result.length - 1; index >= 0; index--) {
        finalResult.push(result[index]);
      }
      return finalResult;
    }
    return result;
  }
}

export default QucikSort;



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/helper/quicksort.js
 **/